// 全局toast提示组件
<template>
<div v-if="toastCnt!==''" class="com-toast">
  <div class="b-t ant-show">
    <p class="p-info">{{toastCnt}}</p>
  </div>
</div>
</template>

<script>
const DefaultTime = 3000;

export default {
  data() {
    return {
      toastCnt:''
    }
  },
  beforeDestroy () {
    // @NOTE 实例销毁前清除定时器
    if(this.sto){
      window.clearTimeout(this.sto);
    }
  },
  methods: {
    show (cnt, time=DefaultTime){
      if (this.sto){
        window.clearTimeout(this.sto);
      }
      this.toastCnt = cnt;
      this.sto = window.setTimeout(function(){
        this.hide();
      }.bind(this),time);
    },
    hide (){
      window.clearTimeout(this.sto);
      this.toastCnt = '';
    }
  }
}
</script>

<style lang="scss">
.com-toast{
  display: block;
  position: fixed;
  top: 40%;
  min-height: 42px;
  width: 100%;
  margin-top: -30px;
  z-index: 3999;
  .b-t{
    display: table;
    position: relative;
    margin: 0 auto;
    padding: 13px 25px;
    min-height: 16px;
    min-width: 100px;
    max-width: 60%;
    background: rgba(0,0,0,.7);
    font-size: 14px;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    .i-icon{
        display: block;
        position: absolute;
        width: 16px;
        height: 16px;
        top:14px;
        left: 45px;
    }
    &.warn {
        background-color: #FEFCEE;
        border-color: #F3D995;
        .icon-warn {
            display: block;
        }
        .p-info{
            color:#DF9C1F;
        }
    }
    .p-info{
        display: inline-block;
        line-height: 16px;
    }
  }

  .ant-show{
    opacity:1 !important;
    -webkit-animation: toastShowKF .7s ease-out;
    animation: toastShowKF .7s ease-out;
  }
  /* 向右渐入动画 */
  @keyframes toastShowKF{
    0%{opacity:0;}
    100%{opacity:1;}
  }
  @-webkit-keyframes toastShowKF{
    0%{opacity:0;}
    100%{opacity:1;}
  }
}

</style>



// WEBPACK FOOTER //
// Toast.vue?7b4d5ace